import { MultiSelectProps } from "@mantine/core"
import { useState } from "react"

import { MultiSelect } from "../Inputs/MultiSelect/MultiSelect"

export function MultiSelectFilter(props: MultiSelectProps) {
  const [searchable, setSearchable] = useState(false)

  return (
    <MultiSelect
      comboboxProps={{
        withinPortal: false,
      }}
      maw={200}
      miw={200}
      searchable={searchable}
      onFocus={() => setSearchable(true)}
      onBlur={() => setSearchable(false)}
      {...props}
    />
  )
}
